<template>
    <div v-if="currentToolSelected && currentToolSelected !== 'search-engine-tool' && currentToolSelected !== 'other-tool'" id="search-queries" class="search-queries tw-relative tw-h-full tw-overflow-y-hidden tw-ml-4 tw-px-2 tw-flex-shrink-0 tw-flex" @scroll="alignQueryLoader">
        <div class="tw-bg-white tw-min-h-full tw-self-start tw-shadow-md tw-border tw-border-solid tw-border-gray-200 sm:tw-rounded-md tw-relative tw-overflow-hidden tw-max-h-full tw-flex tw-flex-col tw-flex-grow" :class="{'tw-cursor-not-allowed tw-opacity-75 tw-pointer-events-none': disabled}">
            <div class="search-queries-header tw-flex tw-px-2 tw-py-2 tw-justify-between tw-bg-brand-area-color tw-items-center tw-sticky tw-top-0">
                <div class="tw-flex tw-flex-col">
                    <div class="tw-font-semibold tw-text-gray-700 tw-mt-3">Search Queries</div>
                </div>
                <div class="tw-flex tw-items-center tw-mt-3">
                    <svg v-if="filterShow && $route.name !== 'monitoring'" @click="onFilterClick" v-tippy content="Filters" xmlns="http://www.w3.org/2000/svg" class="tw-cursor-pointer tw-outline-none tw-mr-4" name="ungroupedComponent" width="24" height="16.799" viewBox="0 0 24 16.799">
                        <path id="filters-solid" d="M22.488,32a1.5,1.5,0,0,1,1.1,2.515l-5.6,6.091V46.4a1.2,1.2,0,0,1-1.92.96l-2.4-1.8a1.192,1.192,0,0,1-.48-.96V40.606l-5.6-6.091a1.434,1.434,0,0,1-.27-1.618A1.483,1.483,0,0,1,8.655,32Zm-21,2.4H6.142a2.711,2.711,0,0,0,.559.926l5.287,5.715v.66l-1.2,1.3V47.6a1.2,1.2,0,0,1-1.92.96l-2.4-1.8a1.192,1.192,0,0,1-.48-.96V43.006l-5.6-6.09a1.5,1.5,0,0,1,1.1-2.516Z" transform="translate(0.012 -32)" fill="#0d69d5" />
                    </svg>
                    <div class="tw-px-1.5 tw-py-0.5 tw--ml-6 tw--mt-6 tw-rounded-full tw-flex tw-text-center tw-items-center tw-bg-red-500 tw-text-sm tw-cursor-pointer" v-if="filterShow && $route.name !== 'monitoring'" v-b-tooltip.hover.top title="Filters Applied">
                        <div class="tw-mx-auto tw-text-xs tw-text-white">{{ toolFiltersCount }}</div>
                    </div>
                    <font-awesome-icon icon="sync" class="tw-cursor-pointer hover:tw-text-blue-400 hover:tw-animate-spin tw-outline-none" :class="{'tw-animate-spin': queriesLoading}" v-tippy content="Refresh Search Queries" @click="handleRefreshQueries"> </font-awesome-icon>
                </div>
            </div>
            <div class="tw-flex tw-px-2 tw-bg-brand-area-color tw-items-center tw-text-sm tw-sticky tw-top-0" v-if="filteredQueries.length > 0 && filterShow && $route.name !== 'monitoring'">
                <input type="checkbox" class="tw-form-checkbox tw-mr-2 tw-h-4 tw-w-4 tw-text-brand tw-cursor-pointer" @click="selectAllQueries(allQuerySelected, true)" v-if="filteredQueries.length > 0 && filterShow && $route.name !== 'monitoring'" :checked="!allQuerySelected" />
                <span> {{ allQuerySelected ? "Select" : "Deselect" }} All</span>
                <button @click="onRunQueries()" :disabled="isEnabledApplyButton" :class="isEnabledApplyButton ? 'tw-bg-gray-500 tw-cursor-not-allowed' : 'tw-bg-brand tw-cursor-pointer hover:tw-bg-brand-hover'" class="tw-border-none tw-rounded tw-text-xs tw-p-1 tw-mb-2 tw-flex tw-items-center tw-ml-auto tw-text-white">
                    View Results
                </button>
            </div>
            <div v-if="filteredQueries.length > 0" class="tw-border-0 tw-border-solid tw-border-gray-200 tw-border-t tw-border-b tw-max-h-full scroll-bar tw-overflow-y-auto tw-h-full tw-flex-grow">
                <div
                    class="tw-relative tw-flex tw-items-center tw-justify-between tw-px-2 tw-py-3 tw-border-0 tw-border-b tw-border-solid tw-border-gray-200 hover:tw-bg-blue-50"
                    v-for="query in filteredQueries"
                    :key="query._id"
                    @click="handleClick(query)"
                    :class="{'tw-bg-blue-100': selectedRow === query._id || (isViewResults && query.run_query === true && query.selected === true), 'tw-line-through': query.monitoring_status === 'disabled' && $route.name === 'monitoring', 'tw-cursor-not-allowed': disabled, 'tw-cursor-pointer': !disabled}"
                >
                    <div class="tw-flex tw-items-center tw-align-middle" :style="getQueryStyle(query)">
                        <div class="tw-flex tw-items-center">
                            <input v-if="filterShow && $route.name !== 'monitoring'" type="checkbox" class="tw-form-checkbox tw-h-4 tw-w-4 tw-text-brand tw-mr-2 tw-cursor-pointer" @change="handleChange($event, query._id)" @click.stop :checked="query.run_query" />
                            <div v-if="monitoring">
                                <neo-toggle-switch :status="query.is_monitoring" :disabled="disabled || (query.sources && Object.keys(query.sources).length === 1 && Object.keys(query.sources).includes('db'))" @click="handleMonitoringStatus(query)" :key="query._id" class="tw-mx-auto tw-p-1 tw-mr-2" />
                                <span class="tw-text-xs tw-text-gray-500">Monitor</span>
                            </div>
                        </div>
                        <span class="tw-truncate tw-w-full tw-ml-2" :title="viewQuery(query)">
                            {{ viewQuery(query) }}
                            <div v-if="showResultsCount" class="tw-flex tw-pt-2 tw-justify-between tw-items-center tw-w-full">
                                <div class="tw-flex tw-gap-3">
                                    <span v-tippy content="Saved Results" class="tw-flex tw-text-gray-400 tw-items-center tw-text-xs tw-gap-1">
                                        <font-awesome-icon icon="save" class="tw-text-xs tw-text-blue-500" style="font-size: 10px"> </font-awesome-icon>
                                        {{ query.saved_results }}
                                    </span>
                                </div>
                                <div class="tw-text-xs tw-ml-auto tw-text-gray-400 tw-font-semibold">Total: {{ query.total_results }}</div>
                            </div>
                        </span>
                        <div class="tw-ml-auto tw-mb-2" v-if="showAnalyser.length > 0 && currentToolSelected == 'news-tool'">
                            <span class="tw-relative tw-inline-block">
                                <img class="tw-cursor-pointer" :src="require('@/assets/icons/search-engines/analyser.svg')" />
                            </span>
                        </div>
                    </div>

                    <!-- {{query.status}} -->
                    <div class="tw-flex">
                        <div class="tw-px-2 tw-py-0.5 tw-rounded-full tw-bg-brand tw-flex tw-text-center tw-items-center" v-if="query.events && ($route.name === 'monitoring' || $route.name === 'monitoring-ro')" v-b-tooltip.hover.top title="Monitoring Events">
                            <div class="tw-font-semibold tw-text-xs tw-text-white tw-mx-auto">{{ query.events }}</div>
                        </div>

                        <span v-if="$route.name !== 'monitoring' && $route.name !== 'monitoring-ro' && (query.status === 'PENDING' || query.status === 'RUNNING' || (query.status === 'DONE' && !query.visited))" class="tw-flex tw-mr-1">
                            <span class="tw-rounded-full tw-flex tw-h-3 tw-w-3 tw-bg-blue-500" v-if="query.status === 'PENDING'"></span>
                            <svg v-else-if="query.status == 'DONE' && !query.visited" xmlns="http://www.w3.org/2000/svg" class="tw-h-5 tw-w-5 tw-text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                            </svg>
                            <span class="tw-flex tw-max-h-4 tw-w-3" v-else-if="query.status === 'RUNNING'">
                                <neo-loader :loading="true"></neo-loader>
                            </span>
                            <span v-else></span>
                        </span>

                        <div class="tw-flex tw--right-2 tw-items-center monitoring-settings-panel tw-pr-1" v-if="$route.name === 'monitoring'" @click="handleSettings($event)">
                            <span :name="query._id" @click="treeData = query">
                                <font-awesome-icon icon="ellipsis-v" class="tw-p-2 tw-h-4 box-size-initial tw-text-gray-400 focus:tw-outline-none" v-if="!query.frequency" v-tippy :content="`Monitoring Settings`"> </font-awesome-icon>
                                <!-- <span class="tw-text-green-600" v-else v-tippy :content="`Frequency`"> {{ getFrequency(query.frequency) }} </span> -->
                                <!-- <div class="tw-px-2 tw-h-5 tw-bg-brand tw-rounded-full tw-flex tw-text-center tw-items-center">
                                <div class="tw-text-xs tw-font-semibold tw-text-white tw-mx-auto" style="line-height: initial">{{ query.frequency }}</div>
                            </div> -->

                                <a class="tw-p-2 tw-text-xs tw-font-semibold tw-text-brand tw-mx-auto tw-no-underline hover:tw-underline" v-else v-tippy :content="`Frequency : ${getFrequency(query.frequency)}`"> {{ query.frequency }} d </a>
                            </span>
                            <tippy :onHidden="hideOptionsBgLayer" :onShow="showOptionsBgLayer" :to="query._id" arrow arrowType="round" interactive theme="light monitoring" trigger="click" maxWidth="500" size="large">
                                <options-widget
                                    :ref="`options-widget-${query._id}`"
                                    :monitoring_data="{
                                        monitoring_status: query.monitoring_status === 'enabled',
                                        frequency: query.frequency,
                                    }"
                                    source="monitoring-query"
                                    :tool="currentToolSelected"
                                    @updateFrequency="updateFrequency(query, true)"
                                    @updateMonitoring="updateMonitoring"
                                >
                                </options-widget>
                            </tippy>
                            <div ref="optionsbgLayer" id="optionsbgLayer" @click="isOpen = false"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tw-text-base tw-text-gray-500 tw-px-2 tw-h-full tw-flex-grow" v-else>
                No Query Found!
            </div>
            <span id="queries-loader" class="tw-absolute tw-bg-blue-100 tw-px-4 tw-py-2 tw-max-h-20 tw-rounded-lg tw-text-center tw-top-1/2 tw-w-full" v-if="queriesLoading || disabled">
                <div class="spinner-4" style="margin-left: calc(50% - 15px)"></div>
                <span class="tw-ml-2">Please wait... Fetching Data.</span>
            </span>
        </div>
    </div>
</template>

<script>
// import NeoTreeview from "@/components/treeview";
import NeoLoader from "@/components/loader";
import NeoToggleSwitch from "@/components/toggle-switch";
import optionsWidget from "@/components/options-widget";
import {TippyComponent} from "vue-tippy";
import {mapMutations, mapActions, mapGetters} from "vuex";
import {capitalize, cloneDeep} from "lodash";
import axios from "@/axios";
import {EventBus} from "@/main.js";

export default {
    name: "SearchQueries",
    data() {
        return {
            mouseOverMonitoring: false,
            componentKey: 0,
            queriesLoading: false,
            treeData: null,
            filterShowTool: ["adverse-media-tool", "offshoreleaks-tool", "news-tool", "world-compliance-tool"],
            selectedQueries: [],
        };
    },
    props: {
        currentToolSelected: String,
        queries: Array,
        input_value_list: Array,
        monitoring: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        toolMonitoring: {
            type: Boolean,
            default: false,
        },
        toolFiltersCount: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        ...mapGetters(["getSelectedToolQuery", "searchedQueries", "getCaseId", "getAnalyzerOptions", "getPermissions", "getAutoAnalyze"]),
        showAnalyser() {
            return this.getAnalyzerOptions.filter((res) => res.selected);
        },
        showResultsCount() {
            return ["adverse-media-tool", "news-tool", "company-name", "offshoreleaks-tool", "lexis-bridger-tool", "world-compliance-tool"].includes(this.currentToolSelected);
        },
        disableMonitoring(query){
            if (this.currentToolSelected === "company-name" && query.sources) {
                return true
            }
        },
        filteredQueries() {
            let filtered = [...this.queries];
            const values = this.input_value_list?.map((n) => n.value);
            if (values?.length > 0) {
                filtered = filtered.filter((query) => {
                    if (this.currentToolSelected === "person-identifier-tool" && (Array.isArray(query?.query?.name) || Array.isArray(query?.query?.email) || Array.isArray(query?.query?.phone) || Array.isArray(query?.query?.locations) || Array.isArray(query?.query?.social_details) || Array.isArray(query?.query?.jobs) || Array.isArray(query?.query?.educations))) {
                        return this.viewQuery(query)
                            .split(",")
                            .some((n1) => values.includes(n1?.trim()));
                    } else if (this.currentToolSelected === "lexis-bridger-tool" || this.currentToolSelected === "world-compliance-tool") {
                        return values.some((n1) => JSON.stringify(query).includes(n1));
                    } else return Object.values(query.query).find((n1) => values.includes(n1));
                });
            }
            // if ((this.$route.name === "monitoring" || this.$route.name === "monitoring-ro") && !this.toolMonitoring) {
            if (this.$route.name === "monitoring" || this.$route.name === "monitoring-ro") {
                filtered = filtered.filter((query) => query.is_monitoring);
                return filtered
                    ?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                    ?.sort((a, b) => {
                        if (a.monitoring_status === "enabled") return -1;
                        else return 1;
                    });
            }
            return filtered?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        },
        selectedRow() {
            return this.getSelectedToolQuery?.query_id ?? this.$route?.query?.query_id;
        },
        tabName() {
            return this.$route.name;
        },
        filterShow() {
            return this.filterShowTool.includes(this.currentToolSelected);
        },
        allResultTools() {
            return ["adverse-media-tool", "news-tool", "offshoreleaks-tool"].includes(this.currentToolSelected);
        },
        allQuerySelected() {
            return !this.filteredQueries.every((query) => query.run_query);
        },
        isEnabledApplyButton() {
            return !this.filteredQueries.some((query) => query.run_query);
        },
        isViewResults() {
            const query = this.selectedQueries.map((n1) => {
                this.filteredQueries.filter((query) => {
                    if (query.run_query && n1 == query._id) {
                        query.selected = true;
                    }
                });
            });
            this.filteredQueries = query;
            return this.filteredQueries;
        },
    },
    components: {
        // NeoTreeview,
        NeoLoader,
        NeoToggleSwitch,
        "options-widget": optionsWidget,
        tippy: TippyComponent,
    },
    mounted() {
        this.alignQueryLoader();
    },
    methods: {
        ...mapMutations(["SET_SELECTED_TOOL_QUERY", "SET_SEARCHED_QUERIES"]),
        ...mapActions(["getToolsStatus"]),
        alignQueryLoader() {
            let totalHeight = document.getElementById("search-queries")?.clientHeight;
            let position = document.getElementById("search-queries")?.scrollTop;
            let component = document.getElementById("queries-loader");
            if (component) component.style.top = position ? `calc(${totalHeight / 2}px - 10px + ${position}px)` : `calc(${totalHeight / 2}px - 10px)`;
        },
        handleClick(query, runQuery) {
            if (query) {
                query["autoAnalyze"] = this.getAutoAnalyze;
                let selectedQuery = {query_id: query._id, query_string: this.viewQuery(query), search_string: this.viewQuery(query), query};
                this.SET_SELECTED_TOOL_QUERY(selectedQuery);
                if (!runQuery) this.$emit("searchQueryClicked", query);
            } else {
                this.SET_SELECTED_TOOL_QUERY(null);
            }
        },
        viewQuery({query}) {
            if (this.currentToolSelected === "adverse-media-tool") {
                return `${query?.name} ( ${query.sources?.filter((el) => el !== "offshoreleaks")?.join(", ")} )`;
            } else if (this.currentToolSelected === "offshoreleaks-tool") {
                return `${query?.name} ( ${query.sources?.join(", ")} )`;
            } else if (this.currentToolSelected === "lexis-bridger-tool") {
                if (query.entity_type === "Individual") return `${query?.person_entity?.full_name} (${query?.entity_type})`;
                else return `${query?.company_entity?.name} (${query?.entity_type})`;
            } else if (this.currentToolSelected === "world-compliance-tool") {
                if (query.entry_type === "Individual") return `${query?.person_entity?.full_name} (${query?.entry_type})`;
                else return `${query?.company_entity?.company_name} (${query?.entry_type})`;
            } else if (this.currentToolSelected === "news-tool") {
                let plain_query = query.query?.split(" near")[0];
                return `${plain_query} ( ${query.sources?.join(", ")} )`;
            } else if (this.currentToolSelected === "company-name") {
                let src = [];
                if (query?.sources) {
                    src = query?.sources.map((source) => {
                        if(source === "db" && this.getPermissions.includes("db__corp_record") && !this.getPermissions.includes("dnb_reseller__corp_record"))
                            source = "d&b"
                        let name = source.toLowerCase()
                        if(source !== "offshoreleaks")
                        return name[0].toUpperCase() + name.slice(1);
                    });
                }
                if(query.name) {
                    return query.sources?.length ? `${query.name} (${src?.join(", ")})` : `${query.name }`
                } else if(query.officer) {
                    return query.sources?.length ? `${query.officer} (${src?.join(", ")})` : `${query.officer}`
                } else if(query.address) {
                    return query.sources?.length ? `${query.address} (${src?.join(", ")})` : `${query.address}`;
                }
                // return query.sources?.length ? `${query.name ?? query.officer ?? query.address} (${src?.join(", ")})` : `${query.name ?? query.officer ?? query.address}`;
            } else if (this.currentToolSelected === "court-records-tool") {
                let searchQueryString = "";
                // according to old tools search judy
                if (query?.search_query) {
                    return `${query?.search_query}`;
                    // according to new tool search judy or uni
                } else if (query?.case_search_list.length) {
                    const dropDownItems = ["condition_operator", "party_types", "partyTypes", "proximity", "representation", "scope", "search_type"];
                    query?.case_search_list.forEach((row) => {
                        for (const key in row) {
                            if (!dropDownItems.includes(key)) {
                                searchQueryString = searchQueryString + row[key] + (row[key].toString().split(" ").length > 1 ? "" : " ");
                                searchQueryString = searchQueryString + ", ";
                            }
                        }
                    });
                    searchQueryString = searchQueryString
                        .replaceAll(" OR ", ", ")
                        .replaceAll(" AND ", ", ")
                        .replaceAll(" NOT ", ", ")
                        .replace(/,\s*$/, "");
                    let names = [];
                    if (query?.sources) {
                        names = query?.sources.map((src) => {
                            let name = src.toLowerCase()
                            return name[0].toUpperCase() + name.slice(1);
                        });
                    }
                    return `${searchQueryString} ( ${names.join(", ") || " "} )`;
                } else {
                    return searchQueryString;
                }
            } else if (this.currentToolSelected === "gdc-tool") {
                let searchQuery = [];
                if (query.identity.first_name || query.identity.middle_name || query.identity.last_name) {
                    searchQuery.push(`${query.identity.first_name + " " + query.identity.middle_name + " " + query.identity.last_name}`);
                }
                if (query.identity.dob) {
                    searchQuery.push(`${query.identity.dob}`);
                }
                if (query.identity?.nationalid?.length > 0) {
                    let ids = [];
                    query.identity.nationalid.forEach((el) => {
                        if (el.id) ids.push(el.id);
                    });
                    if (ids.length > 0) {
                        let nationalids = ids.join(",");
                        searchQuery.push(nationalids);
                    }
                }
                if (query.identity?.organization_name) {
                    searchQuery.push(`${query.identity.organization_name}`);
                }
                if (query.identity.business && query.identity.business.length > 0) {
                    let businessids = [];
                    query.identity.business.forEach((el) => {
                        if (el.id) businessids.push(el.id);
                    });
                    if (businessids.length > 0) {
                        let business_ids = businessids.join(",");
                        searchQuery.push(business_ids);
                    }
                }
                if (query.address.addressLine1 != "" || query.address.houseNumber != "" || query.address.countryCode != "") {
                    searchQuery.push(`${query.address.houseNumber + " " + query.address.addressLine1 + " " + query.address.countryCode}`);
                }
                if (query.address?.district && query.address?.district != "") {
                    searchQuery.push(`${query.address.district}`);
                }
                if (query.address.locality != "" || query.address.postalCode != "" || query.address.province != "") {
                    searchQuery.push(`${query.address.locality + " " + query.address.province + " " + query.address.postalCode}`);
                }
                if (query.email.full_email_address != "") {
                    searchQuery.push(`${query?.email.full_email_address}`);
                }
                if (query.phone.phone_number != "") {
                    searchQuery.push(`${query.phone.phone_number}`);
                }
                return searchQuery.join();
            } else if (this.currentToolSelected == "person-identifier-tool") {
                if (Array.isArray(query?.name) || Array.isArray(query?.email) || Array.isArray(query?.phone) || Array.isArray(query?.locations) || Array.isArray(query?.social_details) || Array.isArray(query?.jobs) || Array.isArray(query?.educations)) {
                    let queryView = [];
                    query?.name?.forEach((res) => {
                        let name = "";
                        if (res && (res.first_name || res.middle_name || res.last_name)) {
                            name = ((res.first_name || "") + " " + (res.middle_name || "") + " " + (res.last_name || "")).trim();
                        }
                        if (name) queryView.push(name);
                    });
                    query?.email?.forEach((res) => {
                        if (res && res.email) {
                            queryView.push(res.email);
                        }
                    });
                    query?.phone?.forEach((res) => {
                        if (res && res.phone) {
                            queryView.push(res.phone);
                        }
                    });
                    query?.location?.forEach((res) => {
                        if (res && (res.country || res.state || res.city)) {
                            queryView.push(res.country + " " + res.state + " " + res.city);
                        }
                    });
                    query?.social_details?.forEach((res) => {
                        if (res && res.social_profile) {
                            queryView.push(res.social_profile);
                        }
                        if (res && res.username) {
                            queryView.push(res.username);
                        }
                    });
                    query?.jobs?.forEach((res) => {
                        if (res && res.organization) {
                            queryView.push(res.organization);
                        }
                    });
                    query?.educations?.forEach((res) => {
                        if (res && res.school) {
                            queryView.push(res.school);
                        }
                    });
                    return queryView.join(", ");
                } else {
                    return Object.entries(query)
                        .map((n) => (n[0] != "page_size" && n[0] != "discover_email" && n[0] != "top_match" && n[0] != "start" ? n[1] : ""))
                        .filter((n) => n)
                        .join(", ");
                }
                return queryView;
            } else if (this.currentToolSelected === "whatsapp-tool") {
                if (query.country_code) {
                    return "+" + query?.country_code + query?.number;
                } else {
                    return query?.number;
                }
            } else if (this.currentToolSelected === "linkedin-tool") {
                query = {...query, email_discover: query["discover_email"]};
                if (query.discovery) {
                    query.discovery = "discovery";
                }
            } else if (this.currentToolSelected === "facebook-tool") {
                if (query.country_code) {
                    return query.country_with_code.split("(")[1].split(")")[0] + query?.number;
                }
            }
            let name = Object.keys(query).filter((n) => n == "name");
            if (name) {
                query = {name: query["name"], ...query};
            }
            return Object.entries(query)
                .map((n) => (n[0] != "page_size" && n[0] != "discover_email" && n[0] != "top_match" && n[0] != "start" ? n[1] : ""))
                .filter((n) => n)
                .join(", ");
        },
        handleMonitoringStatus(query) {
            if (!this.disabled) {
                query.is_monitoring = !query.is_monitoring;
                this.$forceUpdate();
                this.$emit("changeMonitoringStatus", query);
            }
        },
        handleSettings(event) {
            event.stopPropagation();
        },

        getFrequency(frequency) {
            let days = parseInt(frequency, 10) || 0;
            return `${days} days`;
        },

        showOptionsBgLayer() {
            this.isOpen = true;
            const optionsbgLayer = document.getElementById("optionsbgLayer").cloneNode();
            const bgCopy = document.body.appendChild(optionsbgLayer);
            bgCopy.classList = "bg-layer tw-fixed tw-inset-0 tw-bg-black tw-opacity-30 tw-z-50";
            bgCopy.id = "options-bg-copy";
            bgCopy.style.zIndex = " 590";
            this.$refs[`options-widget-${this.treeData._id}`][0]?.initiateOptionsWidget();
        },
        hideOptionsBgLayer() {
            this.isOpen = false;
            const bgCopy = document.getElementById("options-bg-copy");
            bgCopy.remove();
            this.$refs[`options-widget-${this.treeData._id}`][0]?.resetOptionsWidget();
            return true;
        },

        updateFrequency(query, isQuery) {
            this.$emit("updateFrequency", {
                query: query,
                isQuery: isQuery,
                maskedQuery: this.viewQuery(query),
            });
        },

        updateMonitoring(data) {
            this.$emit("updateMonitoring", data);
        },

        async handleRefreshQueries() {
            this.queriesLoading = true;
            await this.getToolsStatus();
            this.queriesLoading = false;
            this.$emit("refreshQueries");
        },

        getQueryStyle(query) {
            if (this.$route.name === "monitoring" || this.$route.name === "monitoring-ro") {
                if (query.events) return "width: calc(100% - 95px)";
                else return "width: calc(100% - 55px)";
            } else {
                if (query.status === "PENDING" || query.status === "RUNNING" || (query.status === "DONE" && !query.visited)) return "width: calc(100% - 24px)";
                else return "width: calc(100% - 4px)";
            }
        },
        onFilterClick() {
            this.$modal.show("tools-filter", {currentToolSelected: this.currentToolSelected});
        },
        selectAllQueries(run_query) {
            const allQueries = cloneDeep(this.searchedQueries).filter((query) => query.tool != this.currentToolSelected);
            let queries = cloneDeep(this.filteredQueries);
            queries = queries.map((query) => ({...query, run_query}));
            this.SET_SEARCHED_QUERIES([...allQueries, ...queries]);
        },
        handleChange({target}, query_id) {
            const queryIndex = cloneDeep(this.searchedQueries).findIndex((query) => query._id == query_id);
            if (queryIndex !== -1) {
                let allQueries = cloneDeep(this.searchedQueries);
                allQueries[queryIndex]["run_query"] = target.checked;
                this.SET_SEARCHED_QUERIES(allQueries);
            }
        },
        onRunQueries() {
            const queries = this.filteredQueries.filter((query) => query.run_query).map((query) => query._id);
            this.selectedQueries = queries;
            this.$emit("onRunQueries", {
                case_id: this.getCaseId,
                tool: this.currentToolSelected,
                queries,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.search-queries {
    .search-queries-header {
        z-index: 1 !important;
    }
    // width: 18%;
    flex: 0 0 16%;
    // height: calc(100% - 26px);
    &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-thumb {
        background: #a8b5c9;
        border-radius: 20rem;
    }
    &::-webkit-scrollbar-corner {
        background: transparent;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #9cadc6;
    }
}
::v-deep {
    .loader {
        width: 16px !important;
        height: 16px !important;
    }

    .toggle-switch {
        @apply tw-h-3;
        @apply tw-w-7;
    }

    .toggle-view {
        @apply tw-h-2;
        @apply tw-w-2;
        @apply tw-ml-1;
    }
}

.box-size-initial {
    box-sizing: initial !important;
}

.spinner-4 {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    padding: 1px;
    margin-right: 1rem;
    background: conic-gradient(#0000 10%, #0d69d5) content-box;
    -webkit-mask: repeating-conic-gradient(#0000 0deg, #000 1deg 20deg, #0000 21deg 36deg), radial-gradient(farthest-side, #0000 calc(100% - 9px), #000 calc(100% - 8px));
    -webkit-mask-composite: destination-in;
    mask-composite: intersect;
    animation: s4 1s infinite steps(10);
}
@keyframes s4 {
    to {
        transform: rotate(1turn);
    }
}
</style>
